const config = {
  API_URL: process.env.REACT_APP_API_URL || " ",
  IMPACT_REPORT_FORM: process.env.REACT_APP_IMPACT_REPORT_FORM || " ",
};

export default config;
